import React, { Component } from "react";
import "./StartPurchaseOrderModal.scss";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";

type Props = {
    closeModalFn: (startPo: boolean) => void;
};

export const StartPurchaseOrderModal: React.FC<Props> = (props) => {
    const closeModal = () => {
        props.closeModalFn(false);
    };

    const start = () => {
        props.closeModalFn(true);
    };

    return (
        <div className={"StartPurchaseOrderModal p-2 "}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-th-list"} title={"create_purchase_order"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div className={"mt-5 text-center"}>
                <OwButton className={"btn btn-success"} fn={start} title={"start"} />
                <OwButton className={"btn btn-danger ms-4"} fn={closeModal} title={"cancel"} />
            </div>
        </div>
    );
};
